module.exports = __webpack_public_path__ + "img/王丽莉.319c7580.jpg";